export const OpportunityTypes = {
    native: 1,
    converted: 2,
    conquest: 3
};